module.exports = __webpack_public_path__ + "static/Sparta-771e0bd791bcfd2358cd6feffc49d4fe.png";